// extracted by mini-css-extract-plugin
export default {"wrapper":"K3-z","play":"L3-z"};